import { useState } from 'react';
import insertUrlParams from '../utils/insertUrlParams';
import getUrlParam from '../utils/getUrlParam';

function getUrlLocationIDs() {
  let locIDs = {
    display: getUrlParam('display') || '',
    trigger_id: getUrlParam('trigger_id') || '',
    asset_id: getUrlParam('asset_id') || '',
    xs_id: getUrlParam('xs_id') || '',
    asset: getUrlParam('asset') || ''
  };
  if (Object.values(locIDs).includes('')) {
    return undefined;
  }
  return locIDs;
}

export default function useLocationIDs() {
  const [locationIDs, setLocationIDs] = useState(getUrlLocationIDs());

  const handleLocationIDsChange = (e) => {
    setLocationIDs(e);
    if (e !== undefined) {
      insertUrlParams(e);
    } else {
      insertUrlParams({
        display: '',
        trigger_id: '',
        asset_id: '',
        xs_id: '',
        asset: ''
      });
    }
  };

  return { locationIDs, handleLocationIDsChange };
}
